import { AppProfile } from '../../../components/app/App';
import LayoutSettings from '../../../components/layout/LayoutSettings';

// Логика аватара и шапки перенесена в PageSettingsProfile.
function PageSettingsAppearance() {
    return (
        <AppProfile title="Настройки персонализации" desc="Настройки персонализации в социальной сети Аквариум">
            <LayoutSettings header="Персонализация" />
        </AppProfile>
    );
}

export default PageSettingsAppearance;
